import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { CheckCircle, ArrowRight, Loader2 } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import type { Business } from "@shared/schema";

export default function CheckoutSuccess() {
  const { data: business, isLoading } = useQuery<Business>({
    queryKey: ["/api/business"],
  });

  const planType = business?.planType;

  const getMessage = () => {
    if (planType === "lifetime") {
      return "Your lifetime access is now active. Let's get you set up.";
    }
    if (planType === "pro") {
      return "Your Pro subscription is active. Let's get you set up.";
    }
    return "Your purchase was successful. Let's get you set up.";
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6">
      <Card className="max-w-md w-full" data-testid="card-checkout-success">
        <CardContent className="pt-8 text-center">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 mb-6">
            <CheckCircle className="w-8 h-8" />
          </div>
          <h1 className="text-2xl font-bold mb-2" data-testid="text-success-headline">
            Welcome to ReviewKit!
          </h1>
          {isLoading ? (
            <div className="flex items-center justify-center mb-8">
              <Loader2 className="w-4 h-4 animate-spin" />
            </div>
          ) : (
            <p className="text-muted-foreground mb-8" data-testid="text-success-message">
              {getMessage()}
            </p>
          )}
          <Link href="/dashboard">
            <Button size="lg" className="gap-2 w-full" data-testid="button-go-to-dashboard">
              Go to Dashboard
              <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
